import clsx from 'clsx';
import { useUiStore } from '../state/uiStore.js';

/**
 * Toaster in-house — render queue from uiStore. Sin react-hot-toast para
 * mantener bundle ligero.
 */
export function Toaster(): JSX.Element {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);
  return (
    <div
      role="region"
      aria-label="notifications"
      className="pointer-events-none fixed right-4 top-16 z-50 flex flex-col gap-2"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={clsx(
            'pointer-events-auto min-w-[240px] max-w-sm rounded border px-3 py-2 text-sm shadow-md',
            t.kind === 'success' && 'border-green-200 bg-green-50 text-green-800',
            t.kind === 'error' && 'border-red-200 bg-red-50 text-red-800',
            t.kind === 'info' && 'border-slate-200 bg-white text-slate-800',
          )}
        >
          <div className="flex items-start justify-between gap-2">
            <span>{t.message}</span>
            <button
              type="button"
              aria-label="dismiss"
              onClick={() => dismiss(t.id)}
              className="text-xs opacity-60 hover:opacity-100"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
